import { GOOGLE_TAG_MANAGER } from 'constants/index'

export const pageview = (url) => {
  if (GOOGLE_TAG_MANAGER && process.env.NEXT_IS_SERVER !== 'true')
    window?.['dataLayer']?.push({
      event: 'pageview',
      page: url,
    })
}
